module.exports = __webpack_public_path__ + "static/media/icon-close.db7db4c1.svg";